import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
// import headerImg from "../assets/img/programmer.png";
import headerImg from "../assets/3D illustartions/1.png";
import { ArrowRightCircle } from 'react-bootstrap-icons';
import 'animate.css';
import TrackVisibility from 'react-on-screen';


import { useTranslation } from 'react-i18next';


export const Banner = () => {

  const { t, i18n } = useTranslation();


  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState('');
  const [delta, setDelta] = useState(300 - Math.random() * 100);
  const [index, setIndex] = useState(1);
  const toRotate = [ "a Full-stack Developer", "a MERN-stack Developer", "an Open Source Contributor" ];
  const period = 2000;

  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);

    return () => { clearInterval(ticker) };
  }, [text])

  const tick = () => {
    let i = loopNum % toRotate.length;
    let fullText = toRotate[i];
    let updatedText = isDeleting ? fullText.substring(0, text.length - 1) : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta(prevDelta => prevDelta / 2);
    }

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setIndex(prevIndex => prevIndex - 1);
      setDelta(period);
    } else if (isDeleting && updatedText === '') {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setIndex(1);
      setDelta(500);
    } else {
      setIndex(prevIndex => prevIndex + 1);
    }
  }


  return (
    <section className="banner" id="home">
      <Container>
        <Row className="aligh-items-center">
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                <span className="tagline">{t('Welcome.1')}</span>
                <h1 id="intro">{t('Hi.1')}  {t('Pronoun.1')} {`Oussama`} <br/> 
                <span className="txt-rotate" dataPeriod="1000" data-rotate='[ "Full-stack Developer", "MERN-tack Developer", "Open Source Contributor" ]'><span className="wrap">{text}</span></span></h1>
                  <p>
                  {t('Intro.1')}
                  </p>
                  <button onClick={() => console.log('connect')}>{t('Connect.1')}<ArrowRightCircle size={25} /></button>
                  <button>
                  <a style={{color:"white",textDecoration:"none"}} href="https://oussama-belhadi-blog.vercel.app/" target="_blank" rel="noreferrer">
                  {t('Check.1')}
                   </a><ArrowRightCircle size={25} /></button>
              </div>}
            </TrackVisibility>
          </Col>
          <Col xs={12} md={6} xl={5}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                  <img src={headerImg} alt="Header Img"/>
                </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
